const axios = require('axios');

async function getMainData() {
  try {
    const resData = await axios.get('/api/v1/admin/statystic');
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { getMainData };
